(function () {
  if (customElements.get('ce-add-to-cart-button') !== undefined) {
    return;
  }

  class AddToCartButton extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        button: '[data-button]',
        iconAddToCartContainer: '[data-add-to-cart-button-icon-add-to-cart-container]',
        iconSpinnerContainer: '[data-add-to-cart-button-icon-spinner-container]',
        iconSpinner: '[data-add-to-cart-button-icon-spinner-container] > svg',
        toaster: 'ce-toaster',
      };

      this._handleClick = this._handleClick.bind(this);
    }

    parsedCallback() {
      this.elements = {
        button: this.querySelector(this.selectors.button),
        iconAddToCartContainer: this.querySelector(this.selectors.iconAddToCartContainer),
        iconSpinnerContainer: this.querySelector(this.selectors.iconSpinnerContainer),
        iconSpinner: this.querySelector(this.selectors.iconSpinner),
        toaster: document.querySelector(this.selectors.toaster),
      };

      this.elements.button.addEventListener('click', this._handleClick);
    }

    disconnectedCallback() {
      this.elements.button.removeEventListener('click', this._handleClick);
    }

    async _handleClick(event) {
      event.preventDefault();

      try {
        this._showSpinner();

        const requestBody = JSON.stringify({
          id: this.getAttribute('variant-id'),
          quantity: 1,
          sections: ['cart-data', 'cart-drawer', 'cart-drawer-notification'],
        });

        const response = await fetch(Themu.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'Content-Type': 'application/json',
          },
          body: requestBody,
        });

        if (!response.ok) {
          const responseBody = await response.json();
          this.elements.toaster.makeToast('warning', responseBody.description, 7000);
          throw Error;
        }

        const responseBody = await response.json();

        document.dispatchEvent(new CustomEvent('Themu:cart:add', { detail: responseBody.sections }));

        // Replace the cart count block (badge)
        const cartCountBlock = document.querySelector('[data-cart-count-block]');
        const updatedCartData = responseBody.sections['cart-drawer-notification'];
        cartCountBlock.classList.add('visible');
        
        if (cartCountBlock && updatedCartData) {
          const temp = document.createElement('div');
          temp.innerHTML = updatedCartData;
        
          const newCountBlock = temp.querySelector('[data-cart-count-block]');
          if (newCountBlock) {
            cartCountBlock.replaceWith(newCountBlock);
          }
        }


        this.elements.toaster.makeToast('success', Themu.t.products.buy_buttons.success_message);
        console.log('added!');
      } catch (error) {
        this.elements.toaster.makeToast('danger', Themu.t.products.buy_buttons.error_message, 7000);
      } finally {
        this._hideSpinner();
      }
    }

    _showSpinner() {
      requestAnimationFrame(() => {
        this.elements.iconAddToCartContainer.style.display = 'none';
        this.elements.iconSpinnerContainer.style.display = 'flex';
      });

      const keyframes = [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }];

      const options = {
        duration: Themu.prefersReducedMotion ? 2000 * 6 : 2000,
        iterations: Infinity,
        fill: 'both',
      };

      this.elements.iconSpinner.animate(keyframes, options);
    }

    _hideSpinner() {
      requestAnimationFrame(() => {
        this.elements.iconAddToCartContainer.style.display = 'inline';
        this.elements.iconSpinnerContainer.style.display = 'none';
      });
    }
  }

  customElements.define('ce-add-to-cart-button', AddToCartButton);
})();
